module.exports = __webpack_public_path__ + "media/images/articles/manners/img01-1dcdf53c664c5eb5265fb5a2b10b0d57.png";